import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";

// 🎨 Estilos del documento
const styles = StyleSheet.create({
  page: {
    padding: 40,
    fontSize: 12,
    fontFamily: "Helvetica",
    color: "#000",
    lineHeight: 1.6,
  },
  header: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  bgImage: {
    opacity: 0.15,
    width: "53vw",
    height: "55vh",
    objectFit: "contain",
    objectPosition: "center",
    position: "absolute",
    top: 170,
    left: 130,
  },
  logoLeft: {
    width: 110,
  },
  logoRight: {
    width: 200,
    height: 50,
    objectFit: "contain",
  },
  body: {
    marginTop: 30,
  },
  title: {
    fontSize: 12,
    marginBottom: 10,
    textAlign: "right",
  },
  recipient: {
    marginTop: 20,
    marginBottom: 20,
    fontWeight: "bold",
  },
  paragraph: {
    textAlign: "justify",
    marginBottom: 10,
    whiteSpace: "pre-line",
    // lineHeight: 1.5,
  },
  bold: {
    fontWeight: "bold",
  },
  signatureSection: {
    marginTop: 20,
    textAlign: "center",
  },
  signatureLine: {
    marginTop: 80,
    borderTopWidth: 1,
    borderColor: "#000",
    width: 220,
    alignSelf: "center",
  },
  footer: {
    position: "absolute",
    bottom: 20,
    left: 40,
    right: 40,
    fontSize: 8,
    textAlign: "left",
    paddingTop: 8,
    lineHeight: 1.3,
  },
  footerImage: {
    position: "absolute",
    bottom: 20,
    right: 40,
    width: 100,
    height: 50,
  },
});

interface ApprovalLetterProps {
  fullName: string;
  projectTitle: string;
  eventName: string;
  eventDates: string;
}

const ApprovalLetter: React.FC<ApprovalLetterProps> = ({
  fullName,
  projectTitle,
  eventName,
  eventDates,
}) => (
  <Document>
    <Page size="A4" style={styles.page}>
      <Image
        style={styles.bgImage}
        src="https://inmchcbmnmgbtgazqkyf.supabase.co/storage/v1/object/public/PdfImages/UAT-Escudo.png"
      />
      <Image
        style={{
          width: "15vw",
          height: "15vh",
          objectFit: "contain",
          objectPosition: "center",
          position: "absolute",
          top: 530,
          left: 250,
        }}
        src="https://inmchcbmnmgbtgazqkyf.supabase.co/storage/v1/object/public/PdfImages/sign.png"
      />
      <Image
        style={{
          width: "20vw",
          height: "20vh",
          objectFit: "contain",
          objectPosition: "center",
          position: "absolute",
          top: 500,
          left: 445,
        }}
        src="https://inmchcbmnmgbtgazqkyf.supabase.co/storage/v1/object/public/PdfImages/stamp.png"
      />
      {/* Encabezado con logotipos */}
      <View style={styles.header}>
        <Image
          style={styles.logoLeft}
          src="https://inmchcbmnmgbtgazqkyf.supabase.co/storage/v1/object/public/PdfImages/logo-uat.jpg"
        />
        <Image
          style={styles.logoRight}
          src="https://inmchcbmnmgbtgazqkyf.supabase.co/storage/v1/object/public/PdfImages/uamvh-logotipo.png"
        />
      </View>

      {/* Fecha y asunto */}
      <Text style={styles.title}>
        Cd. Valle Hermoso Tam., a{" "}
        {new Date().toLocaleDateString("es-MX", {
          day: "numeric",
          month: "long",
          year: "numeric",
        })}
      </Text>
      <Text style={styles.title}>
        Asunto: Carta de Aceptación – 2ª Feria de Emprendedores Universitarios
      </Text>

      {/* Cuerpo del documento */}
      <View style={styles.body}>
        <Text style={styles.recipient}>
          Estimado(a) {fullName.toUpperCase()}
        </Text>

        <Text style={styles.paragraph}>
          {"            "}
          {"            "}Nos complace informarle que su proyecto de
          emprendimiento titulado{" "}
          <Text style={styles.bold}>{`"${projectTitle}"`}</Text> ha sido{" "}
          <Text style={styles.bold}>aceptado</Text> por el Comité Evaluador para
          participar en la <Text style={styles.bold}>{eventName}</Text>, que se
          llevará a cabo el {eventDates} en las instalaciones de la plaza
          principal de nuestra localidad.
        </Text>

        <Text style={styles.paragraph}>
          Su participación como expositor(a) será de gran valor para el evento y
          para los asistentes, contribuyendo al fomento de la innovación y el
          espíritu emprendedor dentro de nuestra comunidad universitaria.
        </Text>

        <Text style={styles.paragraph}>
          Agradecemos su entusiasmo, compromiso y disposición para formar parte
          de esta iniciativa.
        </Text>
        <Text style={styles.paragraph}>
          Sin otro particular, reciba un cordial saludo.
        </Text>
      </View>

      {/* Firma */}
      <View style={styles.signatureSection}>
        <Text>A t e n t a m e n t e</Text>
        <Text>“Verdad, Belleza, Probidad”</Text>
        <Text style={{ fontWeight: "bold", marginTop: 80 }}>
          Mtra. Olga Ellinor Castrellón Rodríguez
        </Text>
        <Text>Secretaría Académica</Text>
      </View>

      {/* Pie de página */}
      <View style={styles.footer}>
        <Text>UNIDAD ACADÉMICA MULTIDISCIPLINARIA VALLE HERMOSO</Text>
        <Text>
          Juárez y 5 de
          mayo&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;
          (894) 842-1559
        </Text>
        <Text>
          Ciudad Valle Hermoso,
          Tamaulipas&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;(834)
          318-1800, ext. 6800
        </Text>
        <Text>
          C.P.
          87500&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;
          www.uat.edu.mx
        </Text>
      </View>
      <Image
        src="https://inmchcbmnmgbtgazqkyf.supabase.co/storage/v1/object/public/PdfImages/Aniversario75.png"
        style={styles.footerImage}
      />
    </Page>
  </Document>
);

export default ApprovalLetter;
